export default __webpack_public_path__ + "f2455c478918ea774af684a34a92f958.png";